__turbopack_context__.v({
  "card": "card-module__uG3VYW__card",
  "content": "card-module__uG3VYW__content",
  "description": "card-module__uG3VYW__description",
  "footer": "card-module__uG3VYW__footer",
  "header": "card-module__uG3VYW__header",
  "title": "card-module__uG3VYW__title",
});
